export default function Particle( config ) {
  this.config = config;

  this.x = config.x || 0;
  this.y = config.y || 0;

  this.direction = Object.assign({
    x: 1,
    y: 1
  }, config.direction );

  this.velocity = Object.assign({
    x: 0,
    y: 0
  }, config.velocity );

  this.bounds = Object.assign({
    w: 0,
    y: 0
  }, config.bounds );

}

Particle.prototype.move = function( scale ) {
  scale = typeof scale === 'undefined' ? 1 : scale;
  this.x += this.velocity.x * scale * this.direction.x;
  this.y += this.velocity.y * scale * this.direction.y;
};

Particle.prototype.toggleDirection = function( axis ) {
  this.direction[ axis ] *= -1;
};
